import { FeedFiltersAction } from '../../actions/feed-filters';
import {
    CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY,
    ChangeFeedFiltersAutobudgetPriorityAction,
    UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY,
    UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT,
    UpdateFeedFiltersAutobudgetPriorityAction,
    UpdateFeedFiltersAutobudgetPriorityResultAction
} from '../../actions/feed-filters/priority-form';
import { PageStatus } from '../../typings/common';
import { FeedFiltersState } from '../../typings/feedFilters';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';

export const PRIORITY_FORM_INITIAL_STATE = {
    autobudgetPriority: GdShowConditionAutobudgetPriority.MEDIUM,
    status: PageStatus.LOADED
};

const changeAutobudgetPriority = (
    state: FeedFiltersState,
    action: ChangeFeedFiltersAutobudgetPriorityAction
): FeedFiltersState => {
    const { autobudgetPriority } = action;

    return {
        ...state,
        priorityForm: {
            ...state.priorityForm,
            autobudgetPriority
        }
    };
};

const updateAutobudgetPriority = (
    state: FeedFiltersState,
    action: UpdateFeedFiltersAutobudgetPriorityAction
): FeedFiltersState => {
    return {
        ...state,
        priorityForm: {
            ...state.priorityForm,
            status: PageStatus.LOADING
        }
    };
};

const updateAutobudgetPriorityResult = (
    state: FeedFiltersState,
    action: UpdateFeedFiltersAutobudgetPriorityResultAction
): FeedFiltersState => {
    const { status } = action;

    switch (status) {
        case PageStatus.ERROR:
            return {
                ...state,
                priorityForm: {
                    ...state.priorityForm,
                    status
                }
            };
        default:
            return {
                ...state,
                priorityForm: PRIORITY_FORM_INITIAL_STATE
            };
    }
};

export const priorityFormReducer = (state: FeedFiltersState, action: FeedFiltersAction): FeedFiltersState => {
    switch (action.type) {
        case CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY:
            return changeAutobudgetPriority(state, action);
        case UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY:
            return updateAutobudgetPriority(state, action);
        case UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT:
            return updateAutobudgetPriorityResult(state, action);
        default:
            return state;
    }
};
